import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { replace as Replace } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@dev/ee-components';

import { addParamToUrl } from '@/services/tools/handleUrlParams';
import { CampaignByTargetStart } from '@/store/campaigns/actions';
import { DEFAULT_ACTIVE_PAGE } from '@/services/constants';
import useMobile from '@/services/hooks/useMobile';
import { debounce } from '@/services/tools/debounce';
import { getLoadParams } from '../tools/getLoadParams';
import { useQueryParams } from '../hooks/useQueryParams';
import { SearchInputStyled } from './StyledComponents';
import { SearchComponentProps } from '../TargetCampaignsProps';

export const SearchComponent = ({ name }: SearchComponentProps): JSX.Element => {
    const isMobile = useMobile();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { search, perPage } = useQueryParams();

    const handleSearchChange = (event?: ChangeEvent<HTMLInputElement>): void => {
        const searchValue = event?.currentTarget?.value;
        debounce(() => {
            const newSearch = addParamToUrl({
                search: searchValue,
                page: DEFAULT_ACTIVE_PAGE,
            });

            dispatch(Replace({ search: newSearch }));

            const loadParams = {
                name,
                search: searchValue,
                page: DEFAULT_ACTIVE_PAGE,
                perPage,
            };
            const params = getLoadParams(loadParams);
            params.nameLike = searchValue;
            dispatch(CampaignByTargetStart(params));
        }, 600);
    };

    return (
        <SearchInputStyled isMobile={isMobile}>
            <SearchInput
                id="search-for-campaigns-input"
                label=""
                placeholder={t('searchforcampaigns')}
                type="text"
                defaultValue={search}
                onChange={handleSearchChange}
                onDelete={handleSearchChange}
            />
        </SearchInputStyled>
    );
};
